module.exports = __webpack_public_path__ + "static/media/vmoda-crossfade-2-wireless.f263062a.jpg";